import React from 'react';
import { string } from 'prop-types';

import { Script } from 'nordic/script';

const snoopyTrackingSites = ['MLC'];

/**
 * @typedef {Object} SnoopySdk
 * @property {string} siteId - The site identifier.
 */
const SnoopySdk = ({ siteId }) => {
  if (!snoopyTrackingSites.includes(siteId?.toUpperCase())) {
    return null;
  }

  return <Script src="https://http2.mlstatic.com/frontend-assets/snoopy-generation-web/v1/snoopy-sdk.js" />;
};

SnoopySdk.propTypes = {
  siteId: string.isRequired,
};

export default SnoopySdk;
